import type { RouteResource } from '@atlassian/react-resource-router';
import { safeCloneResource } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import type { IncomingMailServerExpiryStatusResourceData } from './IncomingMailServerExpiryStatusGetResponse.types.tsx';
import { incomingMailServerExpiryStatusResource } from './useIncomingMailExpiryStatus.tsx';

export const optionalIncomingMailServerExpiryStatusResource: RouteResource<IncomingMailServerExpiryStatusResourceData> =
	safeCloneResource(incomingMailServerExpiryStatusResource, { isPageShellCritical: false });
